// Generated by CoffeeScript 2.7.0
var Mask, capturedBackdrop, disableScrollOnBody, enableScrollOnBody, getOrCreateElementById;

({getOrCreateElementById} = Skylark.Helpers.Utilities);

({disableScrollOnBody, enableScrollOnBody, capturedBackdrop} = Skylark.Helpers.App);

Mask = class Mask {
  static constructContainer() {
    var wrapper;
    this.currentController = $currentController;
    this.isOpen = false;
    this.mask_class_names = [];
    wrapper = DomMaster.wrap(getOrCreateElementById(`${this.type}-element`));
    wrapper.html(`<div class=${this.type}><div class='content'></div></div>`);
    this.mask = wrapper.find(`.${this.type}`);
    this.container = this.mask.find('.content');
    this.container.node.proxy('click', `.js-close-${this.type}`, (event) => {
      return this.dismiss();
    });
    return this._enableBackdrop();
  }

  static updateClassNameOfMask(class_names = '') {
    if (class_names.toString() !== this.mask_class_names.toString()) {
      _.each(this.mask_class_names, (name) => {
        return this.mask.removeClass(name);
      });
      _.each(class_names, (name) => {
        return this.mask.addClass(name);
      });
      return this.mask_class_names = class_names;
    }
  }

  // options:
  //   class_name
  //   #{@type}_class_names (string array)
  //   beforeCloseFunc (function)
  //   backdrop: (boolean: default true)
  static open(content, options = {}) {
    this.beforeCloseFunc = options.beforeCloseFunc;
    this.type = options.type;
    this.backdrop = _.isBlank(options.backdrop) ? true : options.backdrop;
    if (!this.container || this.currentController !== $currentController || !this.isOpen) {
      this.constructContainer();
    }
    this.updateClassNameOfMask(options[`${this.type}_class_names`]);
    this.container.node.className = options.class_name ? `content ${options.class_name}` : 'content';
    this.container.html(content);
    if (!this.isOpen) {
      disableScrollOnBody();
      this.mask.addClass('open');
      this.isOpen = true;
    }
    return this.container;
  }

  static dismiss() {
    if (typeof this.beforeCloseFunc === "function") {
      this.beforeCloseFunc();
    }
    this.beforeCloseFunc = null;
    if (this.isOpen) {
      enableScrollOnBody();
      this.mask.removeClass('open');
      this.isOpen = false;
    }
    return this.container;
  }

  static _enableBackdrop() {
    return capturedBackdrop(() => {
      if (this.backdrop) {
        return {
          force_clean: false
        };
      } else {
        return this.dismiss();
      }
    }, this.container.node);
  }

};

export var Modal = class Modal {
  static open(content, options = {}) {
    return Mask.open(content, _.extend(options, {
      type: 'modal'
    }));
  }

  static dismiss() {
    if (Mask.type === 'modal') {
      return Mask.dismiss();
    }
  }

};

export var Overlay = class Overlay {
  static open(content, options = {}) {
    return Mask.open(content, _.extend(options, {
      type: 'overlay'
    }));
  }

  static dismiss() {
    if (Mask.type === 'overlay') {
      return Mask.dismiss();
    }
  }

};
